/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

// Component
import RpSaleOrder from './RpSaleOrder';
import RpCampaign from './RpCampaign';
import RpPharmacy9 from './RpPharmacy9';
import RpPharmacy10 from './RpPharmacy10';
import RpPharmacy11 from './RpPharmacy11';
import RpSaleOrderList from './RpSaleOrderList';
import RpReturnProduct from './RpReturnProduct';
import RpCancelBill from './RpCancelBill';
import RpCartDelete from './RpCartDelete';
import RpSaleCost from '../report_power_bi/RpSaleCost';
import RpSalesByProduct from './ReportSalesByProduct';
import ReportSalesHour from './ReportSalesHour';

function ReportPOS() {
  const mod = 'report_pos';
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const app = useSelector((state) => state[APP_STATE]);
  const [menu, setMenu] = useState([]);

  const init = () => {
    FetchData('OPTIONS', `/report/load`, app.token, {
      lang: app.lang,
      code: 'pos',
    }).then((result) => {
      if (result.status === 'ok') {
        setMenu(result.data);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, link, key) => {
    return (
      <Grid item xs={12} key={key}>
        <MDButton color='light' href={link} fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            {key}. {name}
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mb={7}>
        <Card sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {menu.map((item, i) =>
              setBtnBadge(t(`menu.${item.code}`), `/${mod}/${item.code}`, i + 1)
            )}
          </Grid>
        </Card>
      </MDBox>
    );
  };

  const renderReport = () => {
    if (id === 'rp_sale_order') return <RpSaleOrder />;
    if (id === 'rp_saleorder_list') return <RpSaleOrderList />;
    if (id === 'rp_product_campaign') return <RpCampaign />;
    if (id === 'rp_sales_by_product') return <RpSalesByProduct />;
    if (id === 'rp_sales_hour') return <ReportSalesHour />;
    if (id === 'rp_pharmacy_9') return <RpPharmacy9 />;
    if (id === 'rp_pharmacy_10') return <RpPharmacy10 />;
    if (id === 'rp_pharmacy_11') return <RpPharmacy11 />;
    if (id === 'rp_return_product') return <RpReturnProduct />;
    if (id === 'rp_cancel_bill') return <RpCancelBill />;
    if (id === 'rp_cart_delete') return <RpCartDelete />;
    if (id === 'rp_sale_cost') return <RpSaleCost />;
    return (
      <MDBox>
        <Navbar route={[t(`menu.report`), t(`menu.report_pos`)]} />
        <MDBox py={3}>{renderButton()}</MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    if (id === undefined) {
      init();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {renderReport()}
      <Footer />
    </DashboardLayout>
  );
}

export default ReportPOS;
